import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { UserContextService, EmployeeProfileService, SpAuthService } from '@core/services';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { EmployeePackage, UserContext } from '../models';

let pendoInstalled = false;

// Well-known events types
export const PENDO_ESS_VALIDATION_EVENT = 'PendoEssValidationEvent';

@Injectable({ providedIn: 'root' })
export class PendoService {
  constructor(
    private authService: SpAuthService,
    private employeeProfileService: EmployeeProfileService,
    private userContextService: UserContextService
  ) {
    if (environment.thirdPartyConfigs.pendoEnabled) {
      combineLatest([
        this.authService.authIds$,
        this.employeeProfileService.employeeProfile$,
        this.userContextService.userContext$,
      ])
        .pipe(take(1))
        .subscribe(([authIds, employeeProfile, userContext]) => {
          this.loadPendoLibrary(authIds.secLoginId, employeeProfile, userContext);
        });
    } else {
      console.warn('Pendo is disabled');
    }
  }

  /**
   * Load the Pendo Tracking (via dynamic script)
   */
  loadPendoLibrary(secLoginId: string, employeeProfile: EmployeePackage, userContext: UserContext) {
    if (!pendoInstalled && environment.pendoId) {
      if (userContext && employeeProfile) {
        const usertype = 'Employee'; // UserRoleType from RA. Hardcoded for ESS
        pendoInstalled = true; // only try to install it once
        // load after the page's first script element
        const ref = window.document.getElementsByTagName('script')[0];
        const script = window.document.createElement('script');
        script.text = `
          (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
            y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/${environment.pendoId}/pendo.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

        try {
          pendo.initialize({
            apiKey: '${environment.pendoId}',
            visitor: { "id": "${secLoginId}", "email": "${employeeProfile.personal.email}", "name": "${userContext.employeeName}", "usertype": "${usertype}" },
            account: { "id": "${employeeProfile.personal.bclCode}", "company": "${userContext.companyName}", "program": "${userContext.programCode}", "partner": "${userContext.partnerCode}"}
          });
        } catch (e) {
          console.error('pendo.initialize failed', e); // report but ignore errors
        }`;

        ref.parentNode.insertBefore(script, ref);
      }
    }
  }
}
